<template>
  <modal-template
    v-if="activeModal === FORGET_PASSWORD"
    size="intermedium"
    :is-static="false"
    @close="closeModal"
  >
    <wegow-loader v-if="loading" class="load-more-loader" :middle="true" />
    <div v-else id="containerSignin">
      <div class="pt-4 md:pt-12 md:mx-16">
        <h3 class="mb-8">{{ $t("wegow.login.forgetPasswordButton") }}</h3>
        <div>
          <form @submit.prevent="forgetPassword(model.email)">
            <div>
              <wegow-input
                id="email-signin"
                v-model:value="model.email"
                :placeholder="$t('wegow.login.email')"
                type="email"
                name="email"
                required
                :validator="validators.email"
                @valid="valid.email = $event"
              />
            </div>
            <div class="text-center mt-6">
              <wegow-button
                background="opacity"
                color="topaz"
                type="submit"
                :disabled="isDisabled"
                :text="$t('wegow.login.forgetPasswordButton')"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal-template>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import { usePurchase } from "@/composables/usePurchase";

import WegowButton from "@/components/general/forms/WegowButton";
import WegowInput from "@/components/general/forms/WegowInput";
import ModalTemplate from "@/components/general/modals/ModalTemplate.vue";
import WegowLoader from "@/components/general/ui/WegowLoader";

import { useModalHandler } from "@/plugins/useModalHandler";
import { computed, reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";

const { forgetPassword } = useUser();

const { activeModal, FORGET_PASSWORD, closeModal } = useModalHandler();

const loading = ref(false);

const modelTemplate = { email: "", password: "" };
const model = reactive({ ...modelTemplate });
const valid = reactive({ email: false });

const validators = {
  email: { validate: email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "") }
};

const isDisabled = computed(() => Object.values(valid).includes(false));
</script>
<style lang="scss" scoped>
#containerSignin {
  h3 {
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
  }
}
</style>
